<app-navbar-style-three></app-navbar-style-three>

<div class="bg-image" style="height: 100px">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-content">
          <h2>Notice</h2>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <!-- Left side with scrollable column for notices -->
    <div class="col-md-4">
      <article class="item">
        <div class="ticker-wrapper-v-image">
          <ul class="news-ticker-v-image">
            <li *ngFor="let notice of dynamicTape" (click)="showNotice($event, notice)"
              style="border: 1px solid #eeeeee; padding: 10px">
              <div class="thumbnail">
                <div style="border: 1px solid #eeeeee; width: 80px">
                  <div style="background-color: #082c5c" class="text-center">
                    <span style="text-align: center; color: #ffffff">{{
                      notice.Date.getDate() | bengaliNumber
                      }}</span>
                  </div>
                  <div style="background-color: #f2f2f2" class="text-center">
                    <span style="text-align: center; color: #caa545">{{
                      notice.Date.toLocaleString('default', { month: 'short' }) | bengaliMonth
                      }}</span>
                  </div>
                </div>
              </div>
              <div>
                <div style="
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">
                  {{ notice.Text }}
                </div>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
        </div>
      </article>
    </div>

    <!-- Right side with the viewport -->

    <div class="col-md-8" style='margin-bottom: 70px;'>
      <!-- <div class="viewport"> -->
      <!-- Display the selected notice here -->
      <div *ngIf="selectedNotice; else noNotice">
        <div class="notice-title">{{ selectedNotice.Text }}</div>
        <div class="notice-details">
          <div class="notice-content">
            <!-- Display the notice image or pdf here -->
            <div  *ngIf="isImage(selectedNotice.Link)"  class='viewport'>
              <img [src]="'assets/img/school/notice/' + selectedNotice.Link"
                alt="Notice" />
            </div>
            <div *ngIf="!isImage(selectedNotice.Link)">
              <!-- <iframe [src]="'pdfUrl' + selectedNotice.Link" width="100%" height="500px" frameborder="0"></iframe> -->
              <iframe *ngIf="pdfUrl" [src]="pdfUrl" width="100%" height="500px" frameborder="0"
                style="border: none; overflow: hidden;"></iframe>
            </div>
          </div>
        </div>
      </div>
      <ng-template #noNotice>
        <div class="notice-title">Please select a notice to view</div>
      </ng-template>
      <!-- </div> -->
    </div>
  </div>
</div>

<!-- <div class="container">
    <div class="row">
        <div class="col-md-4">
            <div class="notice-list">
                <div class="list-group">
                    <a href="#" class="list-group-item list-group-item-action" *ngFor="let notice of dynamicTape"
                        (click)="showNotice($event, notice)">
                        {{ notice.Text }}
                    </a>
                </div>
            </div>
        </div>

        <div class="col-md-8">
            <div class="viewport">
                <div *ngIf="selectedNotice">
                    <div class="notice-title">{{ selectedNotice.Text }}</div>
                    <div class="notice-details">
                        <div class="notice-content">
                            Display the notice image or pdf here 
                            <img *ngIf="isImage(selectedNotice.Link)"
                                [src]="'assets/img/school/notice/' + selectedNotice.Link" alt="Notice" />
                            <div *ngIf="!isImage(selectedNotice.Link)">
                                PDF Content (Replace this with appropriate PDF viewer)
                            </div>
                        </div>
                        <div class="notice-link">
                            <a [href]="'assets/img/school/notice/' + selectedNotice.Link" target="_blank">View Full
                                Notice</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->